// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const SphereOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"aria-labelby":"title","fill":"currentColor","viewBox":"0 0 512 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 21.33c129.39 0 234.67 105.28 234.67 234.67 0 40.36-96.39 85.33-234.67 85.33-28.63 0-55.34-2-79.9-5.44a577.06 577.06 0 01-5.43-79.89c0-138.28 44.97-234.67 85.33-234.67zm-47.49 4.85C173.18 67.43 149.33 153.7 149.33 256c0 26.69 1.62 52.3 4.65 76.3-81.3-15.1-132.65-46.88-132.65-76.3 0-113.13 80.5-207.8 187.18-229.82zM26.18 303.48c27.07 23.18 73.42 41.44 131.13 51.2 9.8 57.71 28.03 104.07 51.2 131.14-91.35-18.86-163.47-90.98-182.33-182.33zM256 490.68c-29.42 0-61.2-51.35-76.3-132.65 24 3.02 49.61 4.65 76.3 4.65 102.3 0 188.56-23.85 229.82-59.18C463.81 410.18 369.13 490.67 256 490.67z"}}]},"name":"sphere","theme":"outlined"};

const SphereOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={SphereOutlinedSvg} />;
  SphereOutlined.displayName = 'SphereOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(SphereOutlined);
